import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldAlert, ArrowLeft, LayoutDashboard } from 'lucide-react';

const Unauthorized = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        padding: '40px 20px',
        textAlign: 'center',
      }}
    >
      <div
        style={{
          width: '72px',
          height: '72px',
          borderRadius: '50%',
          background: 'var(--red-bg, #fee2e2)',
          color: 'var(--red, #dc2626)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: '20px',
        }}
      >
        <ShieldAlert size={36} strokeWidth={1.8} />
      </div>

      <h1
        style={{
          fontFamily: 'Playfair Display, serif',
          fontSize: '28px',
          color: 'var(--navy)',
          marginBottom: '8px',
        }}
      >
        Access Denied
      </h1>

      <p
        style={{
          fontSize: '14px',
          color: 'var(--text-mid)',
          maxWidth: '420px',
          marginBottom: '24px',
          lineHeight: 1.6,
        }}
      >
        You don't have permission to view this page. If you believe this is a
        mistake, contact your organization administrator.
      </p>

      <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', justifyContent: 'center' }}>
        <button
          className="btn btn-ghost btn-sm"
          onClick={() => navigate(-1)}
          style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}
        >
          <ArrowLeft size={14} /> Go Back
        </button>
        <button
          className="btn btn-gold btn-sm"
          onClick={() => navigate('/dashboard')}
          style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}
        >
          <LayoutDashboard size={14} /> Back to Dashboard
        </button>
      </div>
    </div>
  );
};

export default Unauthorized;